import axios from 'axios';
import Forms from '../components/forms';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
export default class ContactForm {
    constructor() {
        this.section = document.querySelector('.contact-form');
        this.form = this.section.querySelector('#contactForm');
        this.formFields = this.form.querySelectorAll('input, select, textarea')
        this.errorView = this.form.querySelector('.contactError');
        this.errorSendForm = this.form.querySelector('.sendFormError');
        this.successView = this.form.querySelector('.contactSuccess');
        this.btnSubmit = this.form.querySelector('button')
        
        Forms.maskField()
        this.initRecaptcha()
        this.ready()
    }

    ready() {
        new Bouncer(`#contactForm`, {
            fieldClass: 'error-field',
            disableSubmit: true,
            ...Forms.wrongMessages(),
        });

        document.addEventListener('bouncerShowError', (event) => {
            this.formFields.forEach(field => {
                if(field.classList.contains('error-field')) {
                    this.errorView.classList.remove('hidden')
                    this.errorView.scrollIntoView({ behavior: 'smooth' });
                }
            })

        }, false);

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendFormContactAjax(event.target);
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formFields.forEach(field => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            })
        })
    }

    sendFormContactAjax(form) {
        this.btnSubmit.disabled = true;
        
        reloadCaptcha('contact', 'g-recaptcha-response', () => {
			this.btnSubmit.disabled = true
			const dataForm = new FormData(form)
            
			if (this.form.querySelector('#privacy').checked) {
                dataForm.set('privacy', 1);
			} else {
                dataForm.set('privacy', 0);
			}
	
			axios({
                method: 'POST',
                url: window.location.protocol+"//"+window.location.hostname+'/send-contact',
                data: dataForm,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(() => {
                    form.reset();
                    this.btnSubmit.disabled = false;
                    this.errorView.classList.add('hidden')
                    this.errorSendForm.classList.add('hidden')
                    this.successView.classList.remove('hidden')
                    this.successView.scrollIntoView({ behavior: 'smooth' });
                })
                .catch(() => {
                    console.log('Erro');
                    this.successView.classList.add('hidden')
                    this.errorView.classList.add('hidden')
                    this.errorSendForm.classList.remove('hidden')
                    this.errorSendForm.scrollIntoView({ behavior: 'smooth' });
                    this.btnSubmit.disabled = false;
                });
		})
    }



}

if (document.querySelector('.contact-form')) {
    new ContactForm();
}
